import {
  AuthenticationDetails,
  CognitoUser,
  CognitoUserAttribute,
  CognitoUserPool,
  ICognitoUserPoolData,
} from 'amazon-cognito-identity-js';

const { VITE_USER_POOL_ID_AWS, VITE_CLIENT_ID_AWS } = import.meta.env;

const poolData: ICognitoUserPoolData = {
  UserPoolId: VITE_USER_POOL_ID_AWS || '',
  ClientId: VITE_CLIENT_ID_AWS || '',
};

export const login = (cognitoUser: CognitoUser, authDetails: AuthenticationDetails, password: string) =>
  new Promise((resolve, reject) => {
    cognitoUser.authenticateUser(authDetails, {
      onSuccess: (data) => {
        cognitoUser.setSignInUserSession(data);
        resolve(data);
      },
      onFailure: (error) => {
        reject(error);
      },
      newPasswordRequired: (data) => {
        cognitoUser.completeNewPasswordChallenge(password, null, {
          onSuccess: (data) => {
            cognitoUser.setSignInUserSession(data);
            resolve(data);
          },
          onFailure: (error) => {
            reject(error);
          },
        });
      },
    });
  });

export const resendVerifyAccount = (email: string) =>
  new Promise((resolve, reject) => {
    const UserPool = new CognitoUserPool(poolData);
    const userData = {
      Username: email,
      Pool: UserPool,
    };
    const cognitoUser = new CognitoUser(userData);
    cognitoUser.resendConfirmationCode((error, result) => {
      if (error) {
        reject(error);
      } else {
        resolve(result);
      }
    });
  });

export const signUp = (email: string, password: string, attributeList: CognitoUserAttribute[]) =>
  new Promise((resolve, reject) => {
    const UserPool = new CognitoUserPool(poolData);
    UserPool.signUp(email, password, attributeList, attributeList, (err, result) => {
      if (err) {
        reject(err);
      } else {
        resolve(result);
      }
    });
  });

export const resetPassword = async (email: string) =>
  new Promise((resolve, reject) => {
    const UserPool = new CognitoUserPool(poolData);
    const userData = {
      Username: email,
      Pool: UserPool,
    };
    const cognitoUser = new CognitoUser(userData);
    cognitoUser.forgotPassword({
      onSuccess: (data) => {
        resolve(data);
      },
      onFailure: (error) => {
        console.log(error);
        reject(error);
      },
    });
  });

export const confirmResetPassword = async (username: string, newPassword: string, verificationCode: string) =>
  new Promise((resolve, reject) => {
    const UserPool = new CognitoUserPool(poolData);
    const userData = {
      Username: username,
      Pool: UserPool,
    };
    const cognitoUser = new CognitoUser(userData);
    cognitoUser.confirmPassword(verificationCode, newPassword, {
      onSuccess: (data) => {
        resolve(data);
      },
      onFailure: (error) => {
        console.log(error);
        reject(error);
      },
    });
  });

export default new CognitoUserPool(poolData);
